var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._t("title")],2),_vm._v(" "),_c('div',{staticClass:"small"},[_vm._t("subtitle")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }